export default __webpack_public_path__ + "static/media/French.e04f3142.gif";